import { Formio } from '@formio/js';
import bootstrap5 from '@formio/bootstrap/bootstrap5';

/**
 * Register the official `@formio/bootstrap` Bootstrap 5 template + the
 * Bootstrap Icons (`bi`) iconset on the global Form.io renderer.
 *
 * The template controls the HTML emitted by every Form.io component
 * (form-control, btn, input-group, alert, validation classes, etc.).
 * Without this, Form.io falls back to its built-in `bootstrap` template
 * which expects Font Awesome 4 and a different class set, leaving us with
 * unstyled buttons/icons.
 *
 * `Formio.use()` is idempotent at the framework level — calling it more
 * than once just re-applies the same templates. We still install once via
 * a guard so HMR doesn't spam the console.
 */
let installed = false;

export function registerFormioBootstrap5Template(): void {
  if (installed) return;
  installed = true;

  // `Formio.use` is the Form.io plugin-registration API, not a React Hook.
  // eslint-disable-next-line react-hooks/rules-of-hooks
  Formio.use(bootstrap5);
}
